import { useMemo } from "react";
import {
  COMPANIES_TABLE_COLUMN_LABELS,
  CompaniesTableColumnField,
  CompaniesTableGridColDef,
} from "@pages/member-profile/tab-contents/member-workspace-tab/member-workspace-table-types";
import { ColumnDimension } from "@components/common/data-grid/adm-data-grid-types";
import {
  WorkspaceMemberCountCell,
  WorkspaceMemberRoleCell,
  WorkspaceNameCell,
  WorkspaceOptionCell,
  WorkspaceProjectCountCell,
  WorkspaceTypeRoleCell,
} from "@utils/data-grid-utils/workspace-data-grid-cells";

const columnDimension: ColumnDimension<CompaniesTableColumnField> = {
  name: {
    flex: 1.5,
  },
  role: {
    flex: 1,
  },
  numberOfMembers: {
    flex: 0.5,
  },
  numberOfProjects: {
    flex: 1,
  },
  type: {
    flex: 1,
  },
  options: {
    flex: 1,
    maxWidth: 120,
  },
};

/**
 * @returns the columns definition to be used in the member's workspace table
 */
export function useMemberWorkspacesTableColumns(): CompaniesTableGridColDef[] {
  const columnsMap: Record<
    CompaniesTableColumnField,
    CompaniesTableGridColDef
  > = useMemo(() => {
    return {
      name: {
        field: "name",
        headerName: COMPANIES_TABLE_COLUMN_LABELS.name,
        ...columnDimension.name,
        valueGetter: (_, row) => row.entity.name,
        renderCell: WorkspaceNameCell,
      },

      role: {
        field: "role",
        headerName: COMPANIES_TABLE_COLUMN_LABELS.role,
        ...columnDimension.role,
        getApplyQuickFilterFn: () => null,
        valueGetter: (_, row) => row.entity.role,
        renderCell: WorkspaceMemberRoleCell,
      },

      numberOfMembers: {
        field: "numberOfMembers",
        headerName: COMPANIES_TABLE_COLUMN_LABELS.numberOfMembers,
        ...columnDimension.numberOfMembers,
        getApplyQuickFilterFn: () => null,
        valueGetter: (_, row) => row.entity.memberCount,
        renderCell: WorkspaceMemberCountCell,
      },

      numberOfProjects: {
        field: "numberOfProjects",
        headerName: COMPANIES_TABLE_COLUMN_LABELS.numberOfProjects,
        ...columnDimension.numberOfProjects,
        getApplyQuickFilterFn: () => null,
        valueGetter: (_, row) => row.entity.projectCount,
        renderCell: WorkspaceProjectCountCell,
      },

      type: {
        field: "type",
        headerName: COMPANIES_TABLE_COLUMN_LABELS.type,
        ...columnDimension.type,
        getApplyQuickFilterFn: () => null,
        valueGetter: (_, row) => row.entity.type,
        renderCell: WorkspaceTypeRoleCell,
      },

      options: {
        field: "options",
        type: "actions",
        headerName: COMPANIES_TABLE_COLUMN_LABELS.options,
        ...columnDimension.options,
        align: "right",
        renderCell: (params) =>
          WorkspaceOptionCell(params, "member-workspaces-table"),
      },
    };
  }, []);

  return Object.values(columnsMap);
}
